(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('Specimen', Specimen);

    Specimen.$inject = ['$resource'];

    function Specimen ($resource) {
        var resourceUrl =  'api/specimens/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByLaboratory': { url: 'api/specimens/laboratory', method: 'GET', isArray: true }
        });
    }
})();
